import React, { Component } from "react";
import { Modal, DatePicker, message, Select } from "antd";
import axios from "services/axios";
import _ from "lodash";
import momentTZ from "moment-timezone";
import { getCarName, backFormatRupiah } from "../../../../Utils";
import downloadExcel from "../../../../../services/downloadExcel";

const { Option } = Select;

class ModalDownload extends Component {
  state = {
    isLoading: false,
    rangeTime: [],
    branches: [],
    branch: null,
  };

  componentDidMount() {
    this.fetchBranch();
  }

  // ************************* Function Change Data *************************//
  onChangeRange(date, dateString) {
    this.setState({ rangeTime: dateString });
  }

  onChangeDate(date) {
    const data = momentTZ(date)
      .tz("Asia/Jakarta")
      .format("dddd, D MMMM YYYY HH:mm");
    return data;
  }

  onChangeDownload(date) {
    const data = momentTZ(date).tz("Asia/Jakarta").format("D MMM YYYY");
    return data;
  }

  onChangeDateRange(date) {
    const data = momentTZ(date)
      .tz("Asia/Jakarta")
      .format("D MMMM YYYY HH:mm:ss");
    return data;
  }

  onCancel() {
    this.setState({ rangeTime: [] });
    this.props.visibleModal(false);
  }

  // ************************* Function Download Data *************************//
  filterDataApproval(approval) {
    const { Appraiser, SalesProfile, noBooking } = approval.Appraisal.Booking;

    // Default Value //
    let hargaPenawaran = 0;
    let ruangNego = 0;
    let mrp = 0;
    let hargaPotong = 0;
    let salesName = null;
    let supervisor = null;
    let kacab = null;
    let cabang = null;
    let area = null;

    const commission = approval.ApprovalCommission
      ? approval.ApprovalCommission.commission
      : null;

    const calculationDetail = approval.calculationDetail
      ? approval.calculationDetail
      : null;

    // Tanggal Approval //
    const tglApproval = approval.createdAt;

    // Tanggal Approval Finish//
    const tglApprovalFinish = approval.updatedAt;

    // Status Approval //
    const statusApproval = approval.approvalStatus;

    // Tanggal Booking //
    const tglBooking = approval.Appraisal.Booking.createdAt;

    // Tanggal Appraisal //
    const tglAppraisal = approval.Appraisal.createdAt;

    // Mobil Bekas Appraisal //
    const carName = getCarName(approval.Appraisal.carDetail);

    // Nomor Polisi Mobil Bekas Appraisal //
    const nomorPolisi = approval.Appraisal.licensePlate;

    if (approval.Appraisal.finalPrice) {
      const { finalPrice } = approval.Appraisal;
      // Harga Penawaran //
      hargaPenawaran = finalPrice.hargaFinalAfterNego;

      // Ruang Nego //
      ruangNego = finalPrice.ruangNego;

      // MRP //
      mrp = finalPrice.hargaFinal;

      // Harga Pemotongan //
      hargaPotong = finalPrice.hargaPotong;
    }

    // Find Request MRP //
    const requestMrp = _.find(approval.ApprovalRequestStatuses, {
      status: "Approved",
      status_label: "MRP",
    });

    // Mobil Baru //
    const newCar = approval.NewCar ? approval.NewCar.carName : null;

    //OTR Mobil Baru //
    const otr = approval.NewCar ? approval.NewCar.otr : null;

    // Diskon Kacab //
    const discountKacab = null;

    //Diskon OM //
    const discountOm = _.find(approval.ApprovalRequestStatuses, {
      status: "Approved",
      status_label: "Discount",
    });

    // Harga Final Approval //
    const hargaFinal = approval.finalPrice;

    // Proyeksi Proyeksi NPBT AAT//
    const NBPTATT = _.find(calculationDetail, { name: "Proyeksi NPBT AAT" });

    // Proyeksi GP After Disc //
    const gpAfterDisc = _.find(calculationDetail, {
      name: "Proyeksi GP After Disc",
    });

    // Total Benefit TI //
    const totalBenefitTI = _.find(calculationDetail, {
      name: "Total Benefit TI",
    });

    // Sisa Ruang Nego //
    const sisaRuangNego = _.find(commission, { name: "Sisa Ruang Nego" });

    // Nama Appraiser //
    const appraiser = Appraiser ? Appraiser.name : null;

    if (SalesProfile) {
      // Nama Sales //
      salesName = SalesProfile.name;

      // Nama Supervisor //
      supervisor = SalesProfile.Supervisor
        ? SalesProfile.Supervisor.name
        : null;

      if (SalesProfile.SalesBranch) {
        const { SalesBranch } = SalesProfile;
        // Nama Kacab //
        kacab = SalesBranch.Kacab ? SalesBranch.Kacab.name : null;

        // Nama Cabang Salesman //
        cabang = SalesBranch.branch;

        // Area Cabang //
        area = SalesBranch.area;
      }
    }

    const mobbiId =
      _.get(approval, "Appraisal.Booking.MobbiPayload.mobbiId") || "-";

    return {
      "Tanggal Approval": this.onChangeDate(tglApproval),
      "Tanggal Approval Finish":
        statusApproval !== "Dalam Proses"
          ? this.onChangeDate(tglApprovalFinish)
          : null,
      "Status Approval": statusApproval,
      "Tanggal Booking": this.onChangeDate(tglBooking),
      "Tanggal Appraisal": this.onChangeDate(tglAppraisal),
      "Id Mobbi": mobbiId,
      "Id Booking": noBooking,
      Cabang: cabang,
      Area: area,
      "Unit Trade In": carName,
      "Plat no Used Car": nomorPolisi,
      "Harga Penawaran": hargaPenawaran,
      "Ruang Nego": ruangNego,
      MRP: mrp,
      "Koreksi MRP": requestMrp
        ? requestMrp.requestPriceEdited
          ? requestMrp.requestPriceEdited
          : requestMrp.requestPrice
        : null,
      "Tanggal Request MRP": requestMrp
        ? this.onChangeDate(requestMrp.createdAt)
        : null,
      "Tanggal Approved MRP": requestMrp
        ? this.onChangeDate(requestMrp.updatedAt)
        : null,
      "Unit New Car": newCar,
      Otr: otr,
      "Diskon Kacab": discountKacab,
      "Diskon OM": discountOm
        ? discountOm.requestPriceEdited
          ? discountOm.requestPriceEdited
          : discountOm.requestPrice
        : null,
      "Tanggal Request Diskon": discountOm
        ? this.onChangeDate(discountOm.createdAt)
        : null,
      "Tanggal Approved Diskon": discountOm
        ? this.onChangeDate(discountOm.updatedAt)
        : null,
      "Harga Final": hargaFinal,
      "Sisa Ruang Nego": sisaRuangNego
        ? backFormatRupiah(sisaRuangNego.value)
        : 0,
      "Proyeksi GP After Disc": gpAfterDisc ? gpAfterDisc.price : 0,
      "Proyeksi NPBT AAT": NBPTATT ? NBPTATT.price : 0,
      "Total Benefit TI": totalBenefitTI ? totalBenefitTI.price : 0,
      "Harga Pengurangan Appraisal": hargaPotong,
      "Nama Sales": salesName,
      "Nama Appraiser": appraiser,
      "Nama Kacab": kacab,
      "Nama Supervisor": supervisor,
    };
  }

  async fetchBranch() {
    const {
      data: { branches },
    } = await axios.get(`/misc/branches`);
    this.setState({ branches });
  }

  getStatus() {
    let data = "";
    let { status } = this.props;
    if (status === "new-approval") data = "(New)";
    else if (status === "deal") data = "(Deal)";
    else if (status === "no-deal") data = "(No Deal)";
    return data;
  }

  async downloadData() {
    const { rangeTime, branch } = this.state;
    this.setState({ isLoading: true });
    if (rangeTime.length > 0) {
      const data = await axios
        .post(`admin-panel/trade-in/${this.props.status}/download`, {
          rangeTime,
          branch,
        })
        .then((result) => {
          if (result.data.approvalTradeIn.length > 0) {
            const tradeIn = result.data.approvalTradeIn.map((v) => {
              const data = this.filterDataApproval(v);
              return data;
            });
            this.setState({ isLoading: false });
            this.props.visibleModal(false);

            let status = this.getStatus();

            const nameDownload = `Approval ${status} ${this.onChangeDownload(
              this.state.rangeTime[0]
            )} - ${this.onChangeDownload(this.state.rangeTime[1])}`;

            downloadExcel(tradeIn, nameDownload);
            message.success("Berhasil Download Data");
          } else {
            this.setState({ isLoading: false });
            message.error("Data Approval Kosong");
          }
        })
        .catch((err) => {
          this.setState({ isLoading: false });
          message.error("Gagal Download Data");
        });
    } else {
      this.setState({ isLoading: false });
      message.error("Pilih rentang waktu terlebih dahulu");
    }
  }

  render() {
    const { rangeTime } = this.state;
    return (
      <Modal
        title="Download Approval"
        visible={this.props.visible}
        onCancel={() => this.onCancel()}
        onOk={() => this.downloadData()}
        confirmLoading={this.state.isLoading}>
        <p>Pilih range waktu Approval</p>
        <DatePicker.RangePicker
          format="YYYY-MM-DD HH:mm:ss"
          onChange={(date, dateString) => this.onChangeRange(date, dateString)}
        />
        <p></p>
        <p>Pilih cabang</p>
        <Select
          showSearch
          optionFilterProp="children"
          onChange={(branch) => {
            this.setState({ branch });
          }}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }>
          <Option key={0} value="">
            Semua Cabang
          </Option>
          {this.state.branches.map((branch, index) => (
            <Option key={index} value={branch.id}>
              {branch.partnerName}
            </Option>
          ))}
        </Select>
      </Modal>
    );
  }
}

export default ModalDownload;



// WEBPACK FOOTER //
// src/components/Dashboard/Approval/Component/Modal/ModalDownload.js